import { HalfPageAd } from '@/components/Ad/HalfPageAd'
import { RectangleAd } from '@/components/Ad/RectangleAd'
import { Heading } from '@/components/ui-other/text/Heading'
import { loadAppConfig } from 'data/config/loadAppConfig'
import Link from 'next/link'
import { ComponentType } from 'react'
import { ExternalLink } from 'react-feather'
import {
  refereePortalPath,
  SpielerPlusPath,
  trainerPortalPath,
  widgetsHomePath
} from 'shared/urlHelpers'
import { AdType } from 'types'

const Sidebar: ComponentType<{
  adType?: AdType
  adPageId?: string
  adOnly?: boolean
}> = async ({ adType = 'rest', adPageId, adOnly }) => {
  const { fan_services } = await loadAppConfig()

  return (
    <aside className="sidebar relative mb-10">
      {/* Half-Page */}
      <HalfPageAd desktop hideMargin hideTopMargin adPageId={adPageId} />

      {!adOnly && (
        <>
          {/* <div className="container overflow-hidden rounded"> */}
          {/* <Link href={HandballNetPath()} openInNewWindow>
          <Image
            src={imagePath('banner/heretoplay-ticketshop.webp')}
            className="w-full container-offset"
            square
            srcSet={[[300, maxScreenSize]]}
          />
        </Link> */}

          {/* <Link
          href={
            'https://www.handball.net/news/wir-suchen-dich-mitarbeiter-in-m-w-d-content-marketing-fur-handball-net'
          }
          openInNewWindow
        >
          <Image
            src={imagePath('banner/Stellenausschreibung_Handball-net.webp')}
            className="w-full container-offset"
            square
            srcSet={[[300, maxScreenSize]]}
          />
        </Link> */}

          {/* <Link href={heretoplayUrl()} openInNewWindow>
          <Image
            src={imagePath('banner/heretoplay-ticketshop.png')}
            className="w-full container-offset"
            square
            srcSet={[[300, maxScreenSize]]}
          />
        </Link> */}
          {/* </div> */}

          <div className="container-white container-sm">
            <Heading level={3} className="mb-1">
              Fan-Services
            </Heading>
            <div className="view-vertical">
              {fan_services.map((service) => (
                <Link
                  key={`service-${service.id}`}
                  href={service.href || '#'}
                  title={service.title}
                  target={service.target}
                  prefetch={false}
                >
                  {service.name}
                  {service.target === '_blank' ? (
                    <ExternalLink className="inline-block w-4 shrink-0 -mt-0.5 ml-1" />
                  ) : (
                    ''
                  )}
                </Link>
              ))}
            </div>
          </div>

          {/* Medium Rectangle, desktop only (sidebar) */}
          <RectangleAd type={'mediumDefault'} desktop adPageId={adPageId} />

          {/* FanQ Widget v2.1 / 2022-08-01 */}
          <iframe
            src="https://widget.fanq-app.com/fanq/build/frame.htm?wid=290ebf1c-7791-4b62-a42b-9a2a2992507b&style=dhb"
            id="fq_iframe"
            className="fq_iframes"
            scrolling="no"
            frameBorder="0"
            style={{ width: 'clamp(300px,100%,100%)', height: '525px' }}
          />

          {/* Eigenwerbung, Medium Rectangle, desktop only (sidebar) */}
          <RectangleAd type={'mediumSelfPromo'} desktop adPageId={adPageId} />

          <div className="container-white container-sm">
            <Heading level={3} className="mb-1">
              Vereinsservices
            </Heading>
            <div className="view-vertical">
              <Link href={refereePortalPath()} target="_blank" prefetch={false}>
                Schiedsrichterportal
                <ExternalLink className="inline-block w-4 shrink-0 -mt-0.5 ml-1" />
              </Link>
              <Link href={trainerPortalPath()} target="_blank" prefetch={false}>
                Trainercenter
                <ExternalLink className="inline-block w-4 shrink-0 -mt-0.5 ml-1" />
              </Link>
              <Link href={SpielerPlusPath()} target="_blank" prefetch={false}>
                SpielerPlus
                <ExternalLink className="inline-block w-4 shrink-0 -mt-0.5 ml-1" />
              </Link>
              <Link href={widgetsHomePath()} prefetch={false}>
                Widgets
              </Link>
            </div>
          </div>

          {/* <div className="my-10">
            <a href={SpielerPlusAdPath()} target="_blank" rel="noreferrer">
              <Image
                src="/img/partners/spielerplus/300x300.png"
                objectFit="contain"
                className="w-full h-full"
              />
            </a>
          </div> */}
        </>
      )}
    </aside>
  )
}

export default Sidebar
